import { useState, React, useEffect } from "react";
import cardBoxImage from "../../assets/images/cardboxbg.png";
import Back from "../../assets/images/backbtn.svg";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { fetchIndicators } from "../../services/report";
import AddReportForm from "./reportForm";
import { crateDranageIrigation } from "../../services/report";
import showNotification from "./../../components/notification/notification";
import { Button, Modal } from "react-bootstrap";

const AddDranageAndIrigation = () => {
  const navigate = useNavigate();
  const [menubuttons, setMenubuttons] = useState([]);
  const [selectedMenuButtons, setSelectedMenuButtons] = useState([]);
  const [show, setShow] = useState(false);
  const [opacity, setOpacity] = useState(1);

  const addDranageFormik = useFormik({
    initialValues: {
      data: [],
    },
    onSubmit: async (values) => {
      if (values.data.length) {
        const res = await crateDranageIrigation(values);
        if (res.status) {
          // alert("Log created successfully");
          navigate("/");
          showNotification(
            "Drainage and Irrigation data added successfully!",
            " success"
          );
        }
      } else {
        showNotification("Please select Indicator", "danger");
      }
    },
  });

  const getIndicators = async () => {
    const type = 1;
    const res = await fetchIndicators(type);
    if (res.status) {
      console.log("called");
      setMenubuttons(res.data);
    }
  };

  useEffect(() => {
    getIndicators();
  }, []);

  const onIndicatorSelect = (button) => {
    console.log(button);
    const checkExist = selectedMenuButtons.some((x) => x === button._id);
    if (checkExist) {
      setSelectedMenuButtons(
        selectedMenuButtons.filter((value) => {
          return value !== button._id;
        })
      );
    } else {
      setSelectedMenuButtons([...selectedMenuButtons, button._id]);
    }
    const regionId = JSON.parse(localStorage.getItem("data")).regionDetails[0]
      ._id;
    let checkArrayExist = addDranageFormik.values.data.some(
      (details) => details.indicatorId === button._id
    );
    if (checkArrayExist) {
      addDranageFormik.setFieldValue(
        "data",
        addDranageFormik.values.data.filter((value) => {
          return value.indicatorId !== button._id;
        })
      );
    } else {
      addDranageFormik.setFieldValue("data", [
        ...addDranageFormik.values.data,
        {
          regionId: regionId,
          indicatorId: button._id,
          name: button.name,
          count: "",
          comments: "",
        },
      ]);
    }
  };

  const reset = () => {
    let tempArray = [...addDranageFormik.values.data];
    setSelectedMenuButtons([]);
    tempArray.forEach((element) => {
      element.count = "";
      element.comments = "";
    });
    addDranageFormik.setFieldValue("data", []);
  };

  const changeFormValue = (index, value, changeKey) => {
    let tempArray = [...addDranageFormik.values.data];
    tempArray[index][`${changeKey}`] = value;
    addDranageFormik.setFieldValue("data", tempArray);
  };
  const goBack = () => {
    navigate(-1);
  };
  const addUserReset = () => {
    reset();
    setShow(false);
    setOpacity(0);
  };
  const handleClose = () => {
    setShow(false);
    setOpacity(0);
  };
  const handleShow = () => {
    setShow(true);
    setOpacity(1);
  };
  return (
    <div className="theme-container">
      <div className="contentCard2">
        <div className="contentCardHeader addProdctHeader">
          <h3>Add Drainage and Irrigation</h3>
          <button onClick={goBack}>
            <img
              src={Back}
              alt=""
            />{" "}
            BACK
          </button>
        </div>
        <div className="cardbg">
          <img
            src={cardBoxImage}
            alt="card bg"
          />
        </div>
      </div>
      {/* -------------------Form---------------------- */}
      <form onSubmit={addDranageFormik.handleSubmit}>
        <div className="politryStockForm">
          <div className="politryStock ">
            <div className="AddprodRow1Egg">
              <div className="eggLogFarmer">
                <div className="farmersBox">
                  <label>Indicator</label>
                  <div className="buttons">
                    {menubuttons &&
                      menubuttons.map((button, index) => {
                        return (
                          <button
                            key={index}
                            type="button"
                            className={`${
                              selectedMenuButtons?.some((x) => x === button._id)
                                ? "active"
                                : ""
                            }`}
                            onClick={() => onIndicatorSelect(button)}>
                            {button.name}
                          </button>
                        );
                      })}
                  </div>
                </div>
              </div>
            </div>
            {addDranageFormik?.values?.data.map((value, index) => {
              return (
                <AddReportForm
                  index={index}
                  formData={value}
                  changeFormValue={changeFormValue}
                />
              );
            })}
          </div>
          {addDranageFormik.values.data.length ? (
            <div className="bottomButtons">
              <button
                type="submit"
                className="addprdt active"
                id="addprdt">
                Add Drainage And Irrigation
              </button>
              <button
                type="reset"
                className="reset"
                id="rst"
                onClick={handleShow}>
                {" "}
                Reset
              </button>
            </div>
          ) : (
            <div className="select-animal-type">
              {" "}
              <p>Please Select Indicator </p>
            </div>
          )}
        </div>
      </form>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        style={{ opacity: opacity }}>
        <Modal.Header closeButton>
          <Modal.Title> Reset?</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure?</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleClose}>
            No
          </Button>
          <Button
            variant="primary"
            onClick={addUserReset}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AddDranageAndIrigation;
